import { render, staticRenderFns } from "./content.vue?vue&type=template&id=b18ee99a&scoped=true"
import script from "./content.vue?vue&type=script&lang=js"
export * from "./content.vue?vue&type=script&lang=js"
import style0 from "./content.vue?vue&type=style&index=0&id=b18ee99a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b18ee99a",
  null
  
)

export default component.exports